import React from 'react';
import Typography from "@mui/material/Typography";

export default function TrainingsPage(){
  return (
    <div>
      <span>
        <div className='reconect-banner'>
          <h5  className='reconect-text'  style={{ color: "white" }}>TREINAMENTO E DESENVOLVIMENTO</h5>
        </div>
        <Typography className="bullet reconect-training-title-infos">Palestras Empresariais</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Palestras corporativas objetivas e impactantes sobre motivação, inovação, engajamento e gestão da mudança,
              com foco em alinhamento estratégico e inspiração de equipes.
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Eventos Corporativos</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Planejamento e condução de eventos corporativos, workshops e encontros de integração voltados ao engajamento, 
              comunicação de metas e fortalecimento de relacionamentos
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Mentoria</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Acompanhamento individualizado ou em pequenos grupos, inclusive para empresários ou sucessores, conduzido por especialistas, com foco no
              desenvolvimento de carreira, performance profissional e resolução de desafios específicos. Fortalece competências e acelera resultados.
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Capacitação</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Treinamentos práticos e aplicáveis para o desenvolvimento de competências técnicas e comportamentais, alinhados às necessidades reais do negócio,
              como vendas, liderança, processos, entre outros.
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Comunicação assertiva</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Desenvolvimento da comunicação clara e objetiva, promovendo relações mais eficientes, redução de conflitos e decisões mais ágeis.
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Comunicação Organizacional</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Estratégias de comunicação direcionadas aos diferentes níveis da organização, garantindo alinhamento entre gestão, liderança e colaboradores.
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Desenvolvimento da Liderança e Parceiros</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Programas voltados ao fortalecimento da liderança e ao desenvolvimento de parceiros estratégicos preparados para assumir responsabilidades 
              e garantir a continuidade das operações na ausência do líder, alinhados à cultura, valores e objetivos da empresa.
          </span>
        </Typography>
        <br />
        <Typography className="bullet reconect-training-title-infos">Fortalecimento Cultura organizacional</Typography>
        <Typography className="reconect-training-infos">
          <span className="reconect-infos">
            Fortalecemos a cultura da empresa com ações estratégicas que consolidam valores, engajam pessoas e alinham comportamentos aos resultados 
              e propósitos do negócio.
          </span>
        </Typography>
      </span>
      <br />
    </div>
  );
}
